import React, { PureComponent } from "react";
import { Picker, Loading, Tooltip } from "@ss/mtd-react3";
import BrandSearch from "@/pages/BrandAggregation/BrandSearch";
import "./style.scss";
import { fetchData } from "@/utils";
import urls from "@/urls";
import noContent from "@/assets/images/no-content.png";
import keeta_brand_guideline from "@/assets/images/keeta_brand_guideline.png";
import EllipsisTooltip from "@/components/tooltip/ellipsis-tooltip";
import qs from "qs";
import { Resource_Type_Identifier } from "@/utils/constant/teamManagement";
import AllPicker from "@/components/all-picker";
import CollectionDetail from "@/pages/BrandAggregation/CollectionDetail/index.jsx";

const getSortOptions = (activeNav) => {
    const baseOptions = [
        { label: "Recently Updated", value: "Recently Updated" },
        { label: "Most Downloaded", value: "Most Downloaded" },
        { label: "Most Viewed", value: "Most Viewed" }
    ];
    
    if (activeNav === "all") {
        return [{ label: "Default", value: "Default" }, ...baseOptions];
    }
    
    return baseOptions;
};

// 添加排序参数映射
const sortMapping = {
    "Default": "default",
    "Recently Updated": "updateTime",
    "Most Downloaded": "downloadNum",
    "Most Viewed": "browseNum"
};
const navItems = [
    { id: "all", label: "Brand Guidelines" },
    // { id: "introduction", label: "Marketing Resources" },
    // { id: "logo", label: "Brand Designs" }
    // { id: "color", label: "Marketing Designs" },
    // { id: "typography", label: "UI/UX" },
    // { id: "graphic", label: "Basic Assets" },
    { id: "collections", label: "Collection" }
];
// 添加测试数据
const mockData = [
    {
        id: 1,
        title: "Brand Guidelines",
        description: "Keeta design system guidelines",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 2,
        title: "Logo Design",
        description: "Keeta logo variations",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 3,
        title: "Color Palette Color Palette Color Palette Color Palette",
        description: "Primary and secondary colors",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 4,
        title: "Typography",
        description: "Font families and styles",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 5,
        title: "Icons Set",
        description: "UI icons collection",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 6,
        title: "Components",
        description: "UI component library",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 7,
        title: "Illustrations",
        description: "Custom illustration set",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 8,
        title: "Marketing Templates",
        description: "Social media templates",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 9,
        title: "Presentation",
        description: "Slide deck templates",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 10,
        title: "Mobile UI Kit",
        description: "Mobile app design system",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 11,
        title: "Web Templates",
        description: "Website design templates",
        imageUrl: keeta_brand_guideline
    },
    {
        id: 12,
        title: "Email Templates",
        description: "HTML email designs",
        imageUrl: keeta_brand_guideline
    }
];
const sortFormatter = value => (
    <span>
        <span className="sort-label">Sort by</span>
        {value.value}
    </span>
);

export default class SearchResult extends PureComponent {
    constructor(props) {
        super(props);

        const initialActiveNav = "all";
        const initialSortValue = initialActiveNav === "all" ? "Default" : "Recently Updated";
        const initialSortCol = sortMapping[initialSortValue];

        this.state = {
            activeNav: initialActiveNav,
            sortValue: initialSortValue,
            sortCol: initialSortCol,
            searchResults: [],
            catalogueList: [], // 目录数组
            directoryId: "Type",
            loading: false,
            currentPage: 1,
            materialType: 5,
            pageSize: 23,
            keyword: "",
            total: 0,
            hasMore: true, // 添加是否有更多数据的标志
            loading: false, // 加载状态
            showDetail: false, // 显示合集详情
            collectionObj: {},
            isLoadingMore: false
        };
        this.navRefs = {};
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);

        // 从 URL 获取搜索关键词
        const queryMap = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true
        });
        const { keyword } = queryMap;
        if (keyword) {
            this.setState({ keyword }, () => {
                this.searchData();
            });
        }
    }
    // 移除滚动监听
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    // 处理滚动事件
    handleScroll = () => {
        const { isLoadingMore, hasMore } = this.state;
        if (isLoadingMore || !hasMore) return;

        // 检查是否滚动到底部
        const scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;

        if (scrollTop + clientHeight >= scrollHeight - 100) {
            this.loadMore();
        }
    };
    // 加载更多数据
    loadMore = () => {
        const { searchResults, total } = this.state;

        if (searchResults.length >= total) {
            this.setState({ hasMore: false });
            return;
        }

        this.setState(
            prevState => ({
                pageSize: prevState.pageSize + 6,
                isLoadingMore: true
            }),
            () => this.searchData()
        );
    };
    handleSearch = value => {
        this.setState(
            {
                keyword: value,
                searchResults: [] // 清空之前的结果
            },
            () => {
                this.searchData();
            }
        );
    };

    handleSortChange = value => {
        const sortValue = value.value;
        this.setState({ sortValue });
        const sortCol = sortMapping[sortValue];
        this.setState(
            {
                sortCol
            },
            () => {
                this.searchData();
            }
        );
    };
    // 添加导航点击处理方法
    handleNavClick = navId => {
        const newSortValue = navId === "all" ? "Default" : "Recently Updated";
        this.setState({ 
            activeNav: navId,
            sortValue: newSortValue,
            sortCol: sortMapping[newSortValue]
        }, () => {
            if (this.navRefs[navId]) {
                this.navRefs[navId].scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "nearest"
                });
            }
            this.handleDetailClose();
            this.searchData();
        });
    };

    // 添加处理目录 ID 的方法
    getDirectoryId = (directoryId, navId) => {
        if (navId && navId === "collections") {
            return -1;
        }

        if (directoryId === "Type" || directoryId === "all") {
            return "";
        }

        return directoryId;
    };
    searchData = async (isLoadMore = false) => {
        const materialType = Number(Resource_Type_Identifier.BRAND_MATERIAL);
        const {
            activeNav,
            keyword,
            sortCol,
            directoryId,
            pageSize,
            currentPage
        } = this.state;

        try {
            if (!isLoadMore) {
                this.setState({ loading: true });
            }
            // 调用搜索接口
            const response = await fetchData(urls.searchOuter.globalSearchV2, {
                keyword,
                sortCol,
                currentPage,
                pageSize,
                directoryId: this.getDirectoryId(directoryId, activeNav),
                materialType
            });

            this.setState({
                searchResults:
                    this.getDirectoryId(directoryId, activeNav) === -1
                        ? response.list || [] // directoryId 为 -1 时使用 list
                        : response.materialList || [],
                total: response.pagination.total || 0,
                hasMore:
                    response.materialList?.length < response.pagination.total,
                loading: false,
                isLoadingMore: false
            });
        } catch (error) {
            console.error("搜索失败:", error);
            this.setState({
                loading: false,
                searchResults: [],
                hasMore: false,
                isLoadingMore: false
            });
        }
    };
    // 跳转详情页
    handleToAssetDetail = materialCode => {
        // this.props.history.push(`/AssetDetail?materialCode=${materialCode}`);
        window.open(
            `/assets/brand-guidelines/detail?materialCode=${materialCode}`,
            "_blank"
        );
    };
    // 添加下拉框点击事件
    handleMenuClick = item => {
        console.log(item);

        this.setState(
            {
                directoryId: item?.value ? item.value : "Type",
                currentPage: 1 // 重置页码
            },
            this.searchData
        );
    };
    // 关闭详情页
    handleDetailClose = () => {
        this.setState({
            showDetail: false,
            collectionObj: {} // 清空对象
        });
    };
    render() {
        const {
            activeNav,
            sortValue,
            searchResults,
            loading,
            keyword,
            directoryId,
            showDetail,
            collectionObj,
            isLoadingMore
        } = this.state;

        return (
            <div className="search-result-page">
                <div className="search-header">
                    <BrandSearch
                        className="search-result"
                        defaultValue={keyword}
                        onClean={this.handleSearch}
                        onSearch={this.handleSearch}
                        historyKey="searchResultHistory"
                    />
                </div>
                <div className="nav-menu">
                    {navItems.map(item => (
                        <div
                            key={item.id}
                            ref={el => (this.navRefs[item.id] = el)}
                            className={`nav-item ${
                                activeNav === item.id ? "active" : ""
                            }`}
                            onClick={() => this.handleNavClick(item.id)}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
                <div className="result-content">
                    <div className="result-header">
                        {activeNav === "collections" ? (
                            <div></div>
                        ) : (
                            <AllPicker
                                value={directoryId}
                                onChange={this.handleMenuClick}
                            />
                        )}
                        {!showDetail ? (
                            <div className="sort-dropdown">
                                <Picker
                                    options={getSortOptions(activeNav)}
                                    formatter={sortFormatter}
                                    value={sortValue}
                                    onChange={this.handleSortChange}
                                />
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                    {!showDetail ? (
                        loading ? (
                            <div className="loading-state">
                                <Loading className="cde" />
                            </div>
                        ) : searchResults.length > 0 ? (
                            <div>
                                <div className="result-grid">
                                    {searchResults.map((item, index) =>
                                        this.getDirectoryId(
                                            directoryId,
                                            activeNav
                                        ) === -1 ? (
                                            <div
                                                key={item.collectionId}
                                                className="card"
                                                onClick={() =>
                                                    this.setState({
                                                        showDetail: true,
                                                        collectionObj: item
                                                    })
                                                }
                                            >
                                                {/* Collection 卡片内容 */}
                                                <div className="card-img-div">
                                                    {item.relatedMaterials
                                                        ?.slice(0, 3)
                                                        .map(
                                                            (
                                                                imgItem,
                                                                index
                                                            ) => (
                                                                <img
                                                                    key={index}
                                                                    src={
                                                                        imgItem
                                                                            ?.material_img_url[0]
                                                                            ?.fileUrl
                                                                    }
                                                                    alt=""
                                                                    className="card-img-item"
                                                                />
                                                            )
                                                        )}
                                                </div>
                                                <div className="card-info">
                                                    <EllipsisTooltip
                                                        content={
                                                            item.collectionName
                                                        }
                                                        style={{
                                                            fontSize: 20,
                                                            fontWeight: 600,
                                                            margin: 0,
                                                            color: "#111925"
                                                        }}
                                                        compareWidth={380}
                                                    >
                                                        {item.collectionName}
                                                    </EllipsisTooltip>
                                                    <div className="card-info-assets">
                                                        {item?.relatedMaterials
                                                            ?.length || 0}{" "}
                                                        assets
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            // 资源卡片内容
                                            <div
                                                key={item.materialId || index}
                                                className="result-card"
                                            >
                                                <div
                                                    className="card-image"
                                                    onClick={() =>
                                                        this.handleToAssetDetail(
                                                            item.materialCode
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src={(() => {
                                                            try {
                                                                // 解析 materialImgUrl 字符串为对象
                                                                const imgUrls = JSON.parse(
                                                                    item.materialImgUrl
                                                                );
                                                                // 获取第一个图片的 fileUrl
                                                                return (
                                                                    imgUrls[0]
                                                                        ?.fileUrl ||
                                                                    ""
                                                                );
                                                            } catch (e) {
                                                                console.error(
                                                                    "解析图片URL失败:",
                                                                    e
                                                                );
                                                                return ""; // 解析失败返回空字符串
                                                            }
                                                        })()}
                                                        alt={item.materialName}
                                                    />
                                                </div>
                                                <div className="card-info">
                                                    <EllipsisTooltip
                                                        content={
                                                            item.materialName
                                                        }
                                                        className="card-title"
                                                        style={{
                                                            fontSize: 16,
                                                            fontWeight: 500,
                                                            margin: 0,
                                                            marginLeft: 8
                                                        }}
                                                        compareWidth={281.25}
                                                    >
                                                        {item.materialName}
                                                    </EllipsisTooltip>
                                                </div>{" "}
                                            </div>
                                        )
                                    )}
                                </div>
                                {/* 加载更多的loading状态 */}
                                {isLoadingMore && (
                                    <div className="loading">
                                        <Loading
                                            direction={"vertical"}
                                            message={"Loading more..."}
                                        />
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div>
                                <img
                                    className="empty-state"
                                    src={noContent}
                                    alt=""
                                />
                            </div>
                        )
                    ) : (
                        <CollectionDetail
                            {...this.props}
                            collectionObj={collectionObj}
                            onClose={this.handleDetailClose}
                        />
                    )}
                </div>
            </div>
        );
    }
}
